import { Field, InjectedFormProps, reduxForm } from "redux-form";
import { Dispatch } from "redux";
import { useReactiveVar } from "@apollo/client";
import { useEffect } from "react";

import {
  emailType,
  maxLength1000,
  required,
} from "../../formValidation/FormValidation";
import InputField from "../registration/common/InputField";
import SubmitButton from "../buttons/SubmitButton";
import { inviteMember } from "../../actions";
import { EUserManagementGenericError } from "../../interfaces/interfaces";
import { userManagementGenericErrorVar } from "../apollo/LocalState";
import { renderTenantModalGenericError } from "../tenantManagement/common/tenant_modal_common_views";

interface IInviteMemberFormCustomProps {
  closeModalFn: () => void;
  propertyId: string;
}

interface IInviteMemberFormData {
  email: string;
}

const InviteMemberForm: React.FC<
  IInviteMemberFormCustomProps &
    InjectedFormProps<IInviteMemberFormData, IInviteMemberFormCustomProps>
> = ({
  closeModalFn,
  propertyId,
  handleSubmit,
  invalid,
  submitting,
  pristine,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const submit = (value: IInviteMemberFormData, dispatch: Dispatch<any>) => {
    dispatch(
      inviteMember({
        closeInviteMemberModal: closeModalFn,
        email: value.email,
        propertyId,
      })
    );
  };
  useEffect(() => {
    return () => {
      userManagementGenericErrorVar(EUserManagementGenericError.noError);
    };
  }, []);
  const genericError = useReactiveVar(userManagementGenericErrorVar);
  return (
    <form onSubmit={handleSubmit(submit)}>
      <div className="invite-tenant-modal-section">
        <label htmlFor="emailField">Email</label>
        <br />
        <Field
          name="email"
          id="emailField"
          validate={[required, emailType, maxLength1000]}
          component={InputField}
          type="email"
          autoComplete="email"
        />
      </div>
      {genericError !== EUserManagementGenericError.noError &&
        renderTenantModalGenericError({ genericError })}
      <div className="invite-tenant-modal-actions">
        <button
          type="button"
          className="tertiary-btn-small"
          onClick={closeModalFn}
        >
          Cancel
        </button>
        <SubmitButton
          disabled={invalid || submitting || pristine}
          name="Send Invite"
          decorator="tertiary-btn-small tertiary-btn-small-main invite-tenant-modal-actions-submit"
        />
      </div>
    </form>
  );
};

export default reduxForm<IInviteMemberFormData, IInviteMemberFormCustomProps>({
  form: "inviteMember",
})(InviteMemberForm);
